<template>
  <div class="page-wrapper">
    <div class="event-details">
      <div class="info">
        <div class="column basic">
          <div class="user-info">
            <basic-info
              :profilePictureURL="baseURL + eventDetails.profilePictureURL"
              :name="eventDetails.authorName"
              :description="eventDetails.divDescription"
            />
          </div>

          <div class="dates">
            <div class="single-date">
              <b>Datum kreiranja</b>
              <span>{{ eventDetails.createdDate | formatDateTime }}</span>
            </div>
            <div class="single-date">
              <b>Početak</b>
              <span>{{ eventDetails.dateFrom }}</span>
            </div>
            <div class="single-date">
              <b>Kraj</b>
              <span>{{ eventDetails.dateTo }}</span>
            </div>
          </div>
        </div>
        <div class="column right">
          <div class="badges">
            <div style="display: flex">
              <status-badge :status="eventDetails.active"></status-badge>
            </div>
            <div class="btn-wrapper">
              <button @click="openModal" class="btn btn-primary btn--mod">
                <i class="far fa-edit"></i>
              </button>
            </div>
            <!-- <button class="btn btn-medium btn--mod">
              <i v-if="!isTicketInfoExpanded" class="fa fa-expand" aria-hidden="true"></i>
              <i v-if="isTicketInfoExpanded" class="fa fa-compress" aria-hidden="true"></i>
            </button>-->
          </div>
          <div class="description">
            <b>Naziv događaja</b>
            <p>
              {{ eventDetails.body }}
              <br />
            </p>
          </div>
          <div
            class="files-info"
            v-if="!isEventInfoExpanded && eventDetails.medias.length > 0"
            @click="isEventInfoExpanded = true"
          >
            <i class="fa fa-paperclip" aria-hidden="true"></i>
            <span>
              {{ eventDetails.medias.length }}
              {{
                eventDetails.medias.length === 1
                  ? 'fajl'
                  : eventDetails.medias.length > 4
                  ? 'fajlova'
                  : 'fajla'
              }}
            </span>
          </div>
          <div
            class="files-area"
            v-if="isEventInfoExpanded && eventDetails.medias.length > 0"
          >
            <a
              class="file"
              v-for="f in eventDetails.medias"
              :href="baseURL + f.link"
              target="_blank"
              :key="f.link"
            >
              <p>{{ f.file_name }}</p>
              <a>
                <i class="fas fa-file-download"></i>
              </a>
            </a>
          </div>
          <!-- <a
            class="show-more-info"
            v-if="!isPollInfoExpanded && (pollDetails.body.length > 200 || Number(pollDetails.numberOfMedia) > 0)"
            @click="isPollInfoExpanded = true"
          >Proširi pregled</a>-->
          <a
            class="show-more-info"
            v-if="isEventInfoExpanded"
            @click="isEventInfoExpanded = false"
            >Sakrij fajlove</a
          >
          <hr style="width: 100%; margin-top: 12px" />
          <div class="details">
            <div id="map-area" v-if="!isAttendanceWrapperExpanded">
              <div class="map">
                <gmap-map
                  ref="mapRef"
                  :center="mapCenter"
                  :zoom="13"
                  :options="{ streetViewControl: false }"
                  map-type-id="roadmap"
                  style="width: 100%; height: 200px"
                >
                  <gmap-marker
                    ref="marker"
                    :position="mapCenter"
                    :animation="4"
                    :clickable="true"
                    :draggable="false"
                    :opacity="0.8"
                    :icon="{
                      url: require('../../assets/marker_small.png')
                    }"
                  ></gmap-marker>
                </gmap-map>
              </div>
              <div class="map-desc">
                <label for="chosenPlace">
                  <i class="fas fa-map-marker-alt" style="font-size: 30px"></i>
                </label>
                <input
                  type="text"
                  v-model="eventDetails.location"
                  class="form-control"
                  id="chosenPlace"
                  disabled
                />
              </div>
            </div>
            <div
              class="overview"
              :class="{ expanded: isAttendanceWrapperExpanded }"
            >
              <!-- <b v-if="shouldRespondForAttendance">Potvrda prisustva</b> -->
              <!-- <b v-if="eventDetails.active === 'Neaktivno'"
                >Evidencija prisustva</b
              >-->
              <div style="display: flex; justify-content: space-between">
                <div class="switch-view">
                  <a
                    class="show-more-info"
                    v-if="shouldRespondForAttendance"
                    :class="{ active: !isAttendanceStatsVisible }"
                    @click="isAttendanceStatsVisible = false"
                    >Potvrda prisustva</a
                  >
                  <span v-if="shouldRespondForAttendance">/</span>
                  <a
                    class="show-more-info"
                    :class="{
                      active:
                        !shouldRespondForAttendance || isAttendanceStatsVisible
                    }"
                    @click="isAttendanceStatsVisible = true"
                    >Evidencija prisustva</a
                  >
                </div>
                <span
                  class="attendance-toggle-button"
                  v-if="eventDetails.active === 'Neaktivno'"
                >
                  <a
                    class="show-more-info"
                    v-if="!isAttendanceWrapperExpanded"
                    @click="isAttendanceWrapperExpanded = true"
                    >Proširi pregled</a
                  >
                  <a
                    class="show-more-info"
                    v-if="isAttendanceWrapperExpanded"
                    @click="isAttendanceWrapperExpanded = false"
                    >Smanji pregled</a
                  >
                </span>
              </div>

              <div
                class="attendance-stats"
                v-if="isAttendanceStatsWrapperVisible"
              >
                <div class="labels">
                  <div class="stat-column">
                    Dolaze
                    <span>{{ attendancePollComing.length }}</span>
                  </div>
                  <div class="stat-column">
                    Ne dolaze
                    <span>{{ attendancePollNotComing.length }}</span>
                  </div>
                  <div class="stat-column">
                    Možda dolaze
                    <span>{{ attendancePollMaybeComing.length }}</span>
                  </div>
                </div>
                <hr />
                <div class="values">
                  <span v-if="attendancePollComing.length === 0"
                    >0 stanara</span
                  >
                  <div class="stat-column">
                    <div
                      class="user"
                      v-for="user in attendancePollComing"
                      :key="user.id"
                    >
                      <span class="popover" rel="popover" data-placement="top">
                        <i
                          class="fas fa-info-circle expense-tooltip"
                          :title="user.user_full_name"
                        ></i>
                      </span>
                      <img :src="baseURL + user.profile_pic_URL.link" />
                      <span>{{ user.user_full_name }}</span>
                    </div>
                  </div>
                  <div class="stat-column">
                    <span v-if="attendancePollNotComing.length === 0"
                      >0 stanara</span
                    >
                    <div
                      class="user"
                      v-for="user in attendancePollNotComing"
                      :key="user.id"
                    >
                      <span class="popover" rel="popover" data-placement="top">
                        <i
                          class="fas fa-info-circle expense-tooltip"
                          :title="user.user_full_name"
                        ></i>
                      </span>
                      <img :src="baseURL + user.profile_pic_URL.link" />
                      <span>{{ user.user_full_name }}</span>
                    </div>
                  </div>
                  <div class="stat-column">
                    <span v-if="attendancePollMaybeComing.length === 0"
                      >0 stanara</span
                    >
                    <div
                      class="user"
                      v-for="user in attendancePollMaybeComing"
                      :key="user.id"
                    >
                      <span class="popover" rel="popover" data-placement="top">
                        <i
                          class="fas fa-info-circle expense-tooltip"
                          :title="user.user_full_name"
                        ></i>
                      </span>
                      <img :src="baseURL + user.profile_pic_URL.link" />
                      <span>{{ user.user_full_name }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="personal-attendance"
                v-if="isAttendancePersonalWrapperVisible"
              >
                <div
                  id="radio-wrapper"
                  v-if="
                    eventDetails.authorId !==
                      $store.getters.getActiveCommunity.member_id &&
                      eventDetails.active === 'Aktivno'
                  "
                >
                  <div
                    v-for="option in attendanceOptions"
                    :key="option.id"
                    class="radio-group"
                  >
                    <input
                      type="radio"
                      v-model="eventDetails.memberWillAttend"
                      :value="option.id"
                      name="attending"
                      :id="option.name"
                      @click="checkAttendance(option.id)"
                    />
                    <label class="option-label" :for="option.name">{{
                      option.name
                    }}</label>
                  </div>
                  <!-- <button @click="checkAttendance" class="btn btn-primary">
                    Pošalji
                    <i class="fas fa-check"></i>
                  </button>-->
                </div>
              </div>
              <div
                class="attendance-confirmation"
                v-if="eventDetails.active === 'Neaktivno'"
              >
                <div
                  class="user"
                  v-for="user in communityMembers"
                  :key="user.id"
                >
                  <span class="popover" rel="popover" data-placement="top">
                    <i
                      class="fas fa-info-circle expense-tooltip"
                      :title="user.user_full_name"
                    ></i>
                  </span>
                  <img :src="baseURL + user.profile_pic_URL.link" />
                  <span>{{ user.user_full_name }}</span>
                  <div class="options" v-if="!isMemberChecked(user)">
                    <button
                      class="btn btn-primary"
                      @click="approveAttendance(user, '1')"
                    >
                      <i class="fas fa-check"></i>
                    </button>

                    <button
                      class="btn btn-danger"
                      @click="approveAttendance(user, '0')"
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                  <div class="attendance-result" v-if="isMemberChecked(user)">
                    <button class="btn" v-if="hasMemberAttended(user)">
                      <i
                        class="fas fa-check"
                        style="color: rgb(26, 121, 107)"
                      ></i>
                    </button>

                    <button class="btn" v-if="!hasMemberAttended(user)">
                      <i
                        class="fas fa-times"
                        style="color: rgb(220, 54, 69)"
                      ></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="votes-toggle-button">
            <a
              class="show-more-info"
              v-if="!isVotersWrapperExpanded"
              @click="isVotersWrapperExpanded = true"
            >Prikaži glasove</a>
            <a
              class="show-more-info"
              v-if="isVotersWrapperExpanded"
              @click="isVotersWrapperExpanded = false"
            >Sakrij glasove</a>
          </div>-->
        </div>
      </div>
      <div class="comments-area">
        <div id="comments" ref="comments">
          <div class="no-comments" v-if="getCommentsNumber === 0">
            <p>Trenutno nema komentara</p>
          </div>
          <comment v-for="c in comments" :comment="c" :key="c.id"></comment>
        </div>
        <div id="new-comment-section">
          <p class="uploaded-file" v-if="attachmentName">
            {{ attachmentName }}
            <span class="btn btn-primary" @click="clearAttachInput">
              <i class="fas fa-times"></i>
            </span>
          </p>
          <div id="upload-area">
            <div
              id="add-img-wrapper"
              @click="uploadFileClicked"
              v-if="!commentUploadUrl"
            >
              <i class="fas fa-paperclip"></i>
            </div>
            <div id="attached-img-wrapper" v-if="commentUploadUrl">
              <div class="hover-shadow" @click="clearAttachInput">
                <i class="far fa-trash-alt"></i>
              </div>
              <img
                :src="commentUploadUrl"
                id="comment-upload-pic"
                alt="slika"
              />
            </div>
          </div>
          <div class="textarea-wrapper">
            <textarea
              class="form-control"
              :class="{ 'textarea-error': comment.length > 300 }"
              @keydown.enter="handleOnEnter"
              :style="{ height: messageTextAreaHeight + 'px' }"
              ref="messageTextArea"
              rows="1"
              placeholder="Unesite komentar"
              v-model="comment"
              @input="autoresizeTextarea"
            ></textarea>
            <div
              class="character-counter"
              :class="{ 'character-counter-error': comment.length > 300 }"
            >
              {{ comment.length }}/300
            </div>
          </div>

          <div id="new-comment-control">
            <input
              @change="fileAttached"
              ref="commentUpload"
              type="file"
              style="display:none"
            />
            <button
              :disabled="comment.length === 0 || commentSending"
              class="btn btn-primary btn--mod"
              @click="submitMedia"
            >
              <slot>
                <spinner
                  :size="20"
                  line-fg-color="#00796b"
                  v-if="commentSending"
                />
              </slot>
              <slot v-if="!commentSending">Pošalji</slot>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasicInfo from '@/components/common/BasicInfo.vue';
import Comment from '@/components/common/Comment.vue';
import TicketStatusBadge from '@/components/common/TicketStatusBadge.vue';
import { mapActions, mapMutations, mapState } from 'vuex';
import axios from '@/axios/axios.js';
import { formatDateMixin } from '@/mixins/mixins.js';

export default {
  components: {
    basicInfo: BasicInfo,
    comment: Comment,
    statusBadge: TicketStatusBadge
  },
  mixins: [formatDateMixin],
  data() {
    return {
      baseURL: process.env.VUE_APP_OBJECT_STORAGE_URL,
      comment: '',
      commentSending: false,
      commentUploadUrl: '',
      commentUploadFile: null,
      attendanceOptions: [
        { name: 'Dolazim', id: '1' },
        { name: 'Ne dolazim', id: '2' },
        { name: 'Mozda dolazim', id: '3' }
      ],
      isEventInfoExpanded: false,
      isAttendanceWrapperExpanded: false,
      isAttendanceStatsVisible: false,
      messageTextAreaHeight: 40,
      attachmentName: null
    };
  },
  computed: {
    ...mapState('event', [
      'eventDetails',
      'comments',
      'attendancePoll',
      'communityMembers',
      'eventPresence'
    ]),
    getCommentsNumber() {
      if (this.comments == null || this.comments.length === 0) {
        return 0;
      } else {
        return 1;
      }
    },
    mapCenter() {
      return {
        lat: Number(this.eventDetails.locationGpsLat),
        lng: Number(this.eventDetails.locationGpsLong)
      };
    },
    attendancePollComing() {
      if (!this.attendancePoll) {
        return [];
      }
      return this.attendancePoll.filter(e => e.attendance_choice === '1');
    },
    attendancePollNotComing() {
      if (!this.attendancePoll) {
        return [];
      }
      return this.attendancePoll.filter(e => e.attendance_choice === '2');
    },
    attendancePollMaybeComing() {
      if (!this.attendancePoll) {
        return [];
      }
      return this.attendancePoll.filter(e => e.attendance_choice === '3');
    },
    shouldRespondForAttendance() {
      return (
        this.eventDetails.authorId !==
          this.$store.getters.getActiveCommunity.member_id &&
        this.eventDetails.active === 'Aktivno'
      );
    },
    isAttendanceStatsWrapperVisible() {
      return (
        this.eventDetails.active === 'Aktivno' &&
        (this.eventDetails.authorId ===
          this.$store.getters.getActiveCommunity.member_id ||
          this.isAttendanceStatsVisible)
      );
    },
    isAttendancePersonalWrapperVisible() {
      return (
        this.eventDetails.active === 'Aktivno' &&
        this.eventDetails.authorId !==
          this.$store.getters.getActiveCommunity.member_id &&
        !this.isAttendanceStatsVisible
      );
    }
  },
  async created() {
    if (this.eventDetails.active === 'Neaktivno') {
      this.getActiveMembersByCommunity();
      await this.getEventPresence();
    } else {
      if (this.hasMemberReponded()) {
        this.isAttendanceStatsVisible = true;
      }
    }
    this.getEventComments();
    this.getEventAttendancePoll();
  },
  methods: {
    ...mapMutations('modal', ['setEvent', 'showModal']),
    ...mapActions('event', [
      'getEventComments',
      'getActiveMembersByCommunity',
      'getEventAttendancePoll',
      'getEventPresence',
      'getEventDetails'
    ]),
    ...mapActions('modal', ['showFailModal']),
    handleOnEnter(e) {
      if (this.commentSending) {
        return;
      }
      if (e.ctrlKey) {
        this.submitMedia();
      }
    },
    hasMemberReponded() {
      if (
        this.eventDetails.memberWillAttend == '1' ||
        this.eventDetails.memberWillAttend == '2' ||
        this.eventDetails.memberWillAttend == '3'
      ) {
        return true;
      }
      return false;
    },
    autoresizeTextarea(event) {
      event.target.style.height = 'auto';
      event.target.style.height = event.target.scrollHeight + 'px';
      if (event.target.scrollHeight > 110) {
        event.target.style.height = '110px';
      }
    },
    openModal() {
      this.setEvent(this.eventDetails);
      this.showModal('ModalContentEventEdit');
    },
    clearAttachInput() {
      this.$refs.commentUpload.value = '';
      this.commentUploadUrl = '';
      this.commentUploadFile = null;
      this.attachmentName = null;
    },
    uploadFileClicked() {
      if (!this.attachmentName) {
        this.$refs.commentUpload.click();
      }
    },
    fileAttached(event) {
      // validate file size
      if (event.target.files[0].size > 5122059) {
        this.showFailModal('Fajl ne može biti veći od 5MB');
        return;
      }
      // check if attachment is image
      if (this.validateInput(event.target.value)) {
        this.commentUploadUrl = URL.createObjectURL(event.target.files[0]);
      } else {
        this.attachmentName = event.target.files[0].name;
      }
      this.commentUploadFile = event.target.files[0];
    },
    validateInput(value) {
      let allowedExtensions = ['jpg', 'jpeg', 'png'];
      let extension = value.substring(value.lastIndexOf('.') + 1, value.length);
      return allowedExtensions.indexOf(extension) > -1;
    },
    resetInputFields() {
      this.comment = '';
      this.messageTextAreaHeight = 40;
      this.clearAttachInput();
    },
    formatMediaForSubmit() {
      if (this.commentUploadFile != null) {
        let fd = new FormData();
        fd.append(
          'files[]',
          this.commentUploadFile,
          this.commentUploadFile.name
        );
        fd.append('type', 'community');
        fd.append('community_id', this.$store.getters.getActiveCommunity.id);
        return fd;
      }
      return null;
    },
    submitMedia() {
      if (this.comment.trim() === '') {
        return;
      }
      if (this.comment.trim().length > 300) {
        this.showFailModal('Komentar može imati najviše 300 karaktera.');
        return;
      }

      this.commentSending = true;
      if (this.commentUploadFile == null) {
        this.submitForm();
      } else {
        axios
          .post('media/add', this.formatMediaForSubmit(), {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(({ data }) => {
            this.submitForm(data.ids);
          })
          .catch(() => {
            this.commentSending = false;
            this.showFailModal();
          });
      }
    },
    submitForm(mediaData) {
      let postData = {
        body: this.comment.trim(),
        community_id: this.$store.getters.getActiveCommunity.community_id,
        direct_post_receiver_id: 0,
        event: null,
        media_ids: mediaData == null ? '' : mediaData,
        member_id: this.$store.getters.getActiveCommunity.member_id,
        parent_post_id: this.eventDetails.postId,
        post_type: 5,
        voting: null
      };

      axios
        .post('post', postData)
        .then(res => {
          this.commentSending = false;
          this.getEventComments();
          this.resetInputFields();
        })
        .catch(e => {
          this.commentSending = false;
          console.log(e);
        });
    },
    approveAttendance(user, approve) {
      axios
        .post('event/verify', {
          attended: approve,
          event_id: this.eventDetails.eventId,
          manager_member_id: this.$store.getters.getActiveCommunity.member_id,
          member_id: user.id
        })
        .then(data => {
          this.getEventPresence();
        })
        .catch(err => {
          console.log(err);
        });
    },
    isMemberChecked(user) {
      if (
        this.eventPresence === null ||
        this.eventPresence.filter(e => e.user_id === user.user_id).length === 0
      ) {
        return false;
      }
      return true;
    },
    hasMemberAttended(user) {
      if (
        this.eventPresence.filter(e => e.user_id === user.user_id)[0]
          .member_attended === '1'
      ) {
        return true;
      }

      return false;
    },
    checkAttendance(memberWillAttendValue) {
      axios
        .post('event/create-member', {
          event_id: this.eventDetails.eventId,
          member_id: this.$store.getters.getActiveCommunity.member_id,
          will_attend: memberWillAttendValue
        })
        .then(data => {
          this.getEventDetails();
          this.isAttendanceStatsVisible = true;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped lang="scss">
.page-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.character-counter {
  right: 123px;
  bottom: 29px !important;
}

.event-details {
  // display: flex;
  // min-height: calc(100% - 120px);
  height: calc(100vh - 120px);
  padding: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.info {
  // flex: 20%;
  position: relative;
  border: 1px solid gray;
  border-radius: 4px;
  padding: 10px;
  display: flex;
  .column {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &.basic {
      .user-info {
        display: flex;
        padding-right: 6px;
      }
      .dates {
        display: flex;
        flex-direction: column;
        text-align: left;
        margin: 0;
        margin-top: 20px;
        .single-date {
          // margin-top: 2px;
          display: flex;
          flex-direction: column;
          span {
            margin-top: -4px;
          }
        }
      }
    }
    &.right {
      // border: 1px solid red;
      flex: 3;
      justify-content: flex-start;
      .badges {
        // width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        // margin-top: 5px;
        .statbar {
          margin-right: 3px;
        }
      }
      .description {
        padding: 3px 5px;
        // background-color: #fabb4738;
        /* border: 1px solid #000000; */
        border-radius: 3px;
        p {
          max-height: 120px;
          overflow: auto;
          margin-top: 4px !important;
        }
      }
      .files-info {
        border: 1px solid gray;
        border-radius: 6px;
        // width: 140px;
        width: fit-content;
        padding: 4px 8px;
        // padding-left: 10px;
        font-weight: 600;
        display: inline-flex;
        justify-content: center;
        cursor: pointer;
        i {
          font-size: 22px;
          margin-right: 8px;
        }
        &:hover {
          background: rgba(108, 108, 108, 0.05);
        }
      }
      .files-area {
        margin-top: 10px;
        width: 100%;
        text-align: left;
        // max-height: 86px;
        justify-content: space-between;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        resize: none;
        max-height: 14vh;

        .file {
          display: flex;
          align-items: center;
          // flex-shrink: 0;
          flex: 0 0 49%;
          max-width: 49%;
          background-color: #d5d5d54a;
          margin-bottom: 6px;
          margin-right: 6px;
          height: auto;
          // margin: 4px;
          border-radius: 4px;
          color: black;

          p {
            // word-break: break-word;
            margin-bottom: 0;
            width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            // direction: rtl;
            padding: 4px;
          }

          i {
            color: var(--primary-color);
            float: right;
            margin: 0 15px;
          }
        }
      }
      .details {
        display: flex;
        #map-area {
          flex: 1;
          padding-right: 1rem;
          .map-desc {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-top: 4px;
            label {
              margin: 0;
              padding: 0 8px;
              i {
                color: var(--primary-color);
              }
            }
            input {
              text-overflow: ellipsis;
            }
          }
        }
        .overview {
          padding-left: 1rem;
          border-left: 1px solid rgba(0, 0, 0, 0.1);
          flex: 2;

          &.expanded {
            border-left: none;
            padding-left: 0;
            .attendance-confirmation .user {
              flex-basis: 24.25%;
              max-width: 24.25%;
              margin-right: 1%;
              &:nth-child(3n) {
                margin-right: 1%;
              }
              &:nth-child(4n) {
                margin-right: 0;
              }
            }
          }
          .attendance-toggle-button {
            float: right;
          }
          .switch-view {
            width: fit-content;
            padding-right: 24px;
            margin-bottom: 4px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            span {
              margin: 0 6px;
            }
            a.active {
              color: black;
              font-weight: 600;
              pointer-events: none;
            }
          }
          .attendance-confirmation {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            max-height: 210px;
            overflow: auto;
            padding-right: 12px;
            .user {
              height: 54px;
              margin-top: 4px;
              margin-right: 1.25%;
              border: 1px solid rgba(0, 0, 0, 0.1);
              border-radius: 4px;
              // padding: 4px;
              padding-left: 8px;
              flex-basis: 32.5%;
              max-width: 32.5%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              position: relative;
              &:nth-child(3n) {
                margin-right: 0;
              }
              img {
                height: 35px;
                width: 35px;
                object-fit: cover;
                border-radius: 50%;
              }
              span:not(.popover) {
                // max-width: calc(100% - 81px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding: 0 6px;
              }
              .options {
                display: flex;
                flex-direction: column;
                height: 100%;
                .btn {
                  width: 27px;
                  height: 50%;
                  margin: 0;
                  padding: 0;
                  &:first-child {
                    border-radius: 0 4px 0 0;
                  }
                  &:last-child {
                    border-radius: 0 0 4px 0;
                  }
                }
              }
              .attendance-result {
                height: 100%;
                width: 35px;
                flex-shrink: 0;
                button {
                  height: 100%;
                  width: 100%;
                  border-radius: 0 4px 4px 0;
                  cursor: pointer;
                  pointer-events: none;
                  background: white;
                }
              }
              .popover {
                width: calc(100% - 27px);
              }
            }
          }
          .attendance-stats {
            .labels,
            .values {
              width: 100%;
              display: flex;
              justify-content: center;
              .stat-column {
                flex: 1;
                // padding-right: 10px;
                padding: 0 4px;
                text-align: left;
                margin-right: 16px;
              }
            }
            hr {
              margin: 0;
              display: none;
            }
            .labels {
              .stat-column {
                // text-transform: uppercase;
                font-weight: 600;
                border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                border: 1px solid var(--primary-color);
                padding: 2px 6px;
                background: var(--primary-color);
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-radius: 4px;
                color: white;
                span {
                  margin-left: 8px;
                  // color: var(--primary-color);
                  color: white;
                  padding: 2px 6px;
                  border-radius: 4px;
                  font-weight: 600;
                }
              }
            }
            .values {
              .stat-column {
                padding: 0 4px 0 0;
                max-height: 230px;
                overflow: auto;
              }
            }
            .user {
              // border: none;
              height: 40px;
              // width: 90%;
              img {
                height: 30px;
                width: 30px;
              }
            }
          }
          .personal-attendance {
            #radio-wrapper {
              display: flex;
              flex-flow: column;
              align-items: center;
              width: fit-content;
              .radio-group {
                border: solid 1px var(--primary-color);
                margin-top: 0.5rem;
                margin-bottom: 0.5rem;
                border-radius: 10px;
                overflow: hidden;
              }

              .option-label {
                color: var(--primary-color);
                display: inline-block;
                cursor: pointer;
                padding: 5px 20px;
                margin-bottom: 0;
                width: 14rem;
                text-align: center;
              }

              input[type='radio'] {
                position: absolute;
                visibility: hidden;
                display: none;
              }

              input[type='radio']:checked + label {
                color: white;
                background: var(--primary-color);
              }
              button {
                width: 100%;
                margin-top: 1rem;
              }
            }
          }
          .user {
            height: 54px;
            margin-top: 4px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            // padding: 4px;
            padding-left: 8px;
            display: flex;
            align-items: center;
            position: relative;
            &:nth-child(3n) {
              margin-right: 0;
            }
            img {
              height: 35px;
              width: 35px;
              object-fit: cover;
              border-radius: 50%;
            }
            span {
              // max-width: calc(100% - 81px);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0 6px;
            }
            .popover {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 94%;
              opacity: 0;
              i {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
  }
  .btn--mod {
    // position: absolute;
    // right: 10px;
    // top: 10px;
    flex: 0 0 0;
    // margin-left: auto;
    margin-left: 12px;
    padding: 3px;
    vertical-align: middle;
    height: 35px;
    min-width: 75px;
  }
  .show-more-info {
    margin-top: 8px;
    color: var(--primary-color);
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}

.comments-area {
  flex: 80%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  justify-content: space-between;
  #comments {
    overflow: auto;
    padding-right: 10px;
    &.expanded {
      max-height: 54vh;
    }
  }
  #new-comment-section {
    .uploaded-file {
      position: absolute;
      bottom: 55px;
      background: var(--primary-color);
      border-radius: 4px 4px 0 0;
      padding: 0px 8px;
      color: white;
      text-align: left;
      span {
        padding-right: 0;
      }
    }
    // flex: 100px;
    margin-top: 15px;
    height: auto;
    display: inline-flex;
    align-items: flex-end;
    width: 100%;
    textarea {
      resize: none;
    }

    #upload-area {
      // min-width: 40px;
      // max-width: 40px;
      height: 40px;
      width: 45px;
      margin-right: 5px;
      background-color: rgba(211, 211, 211, 0.37);
      border-radius: 5px;
      overflow: hidden;

      #attached-img-wrapper {
        .hover-shadow {
          border-radius: 5px;
          opacity: 0;
          min-width: 40px;
          min-height: 40px;
          background-color: rgba(0, 0, 0, 0.41);
          position: absolute;
          transition: opacity 0.2s;
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            color: white;
          }
        }
      }

      #attached-img-wrapper:hover {
        .hover-shadow {
          opacity: 1;
        }
      }

      #add-img-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .fa-paperclip {
        transition: color 0.25s;
        font-size: 25px;
      }

      img {
        width: 40px;
        height: 40px;
        object-fit: scale-down;
      }
    }

    #upload-area:hover {
      cursor: pointer;
      .fa-paperclip {
        color: var(--primary-color);
      }
    }

    #new-comment-control {
      display: flex;
      float: right;
      align-items: flex-end;

      button {
        margin-left: 5px;
        height: 40px;
        // width: 40px;
        i {
          font-size: 35px;
        }
      }

      #comment-upload-btn {
        margin-right: 5px;
        font-size: 20px;
      }
    }
  }
}
</style>
